.instructionText {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
